module.exports = __webpack_public_path__ + "static/media/culture-image.dc699ae0.webp";